interface User {
  id: string | null
  username: string
  password: string | null
  alerts: number
  telegram_chat_id: string | null
  admin: number
}

interface LoginResponse {
  success: boolean
  user?: User
  error?: string
}

async function login(username: string, password: string): Promise<User | null> {
  try {
    const response = await fetch('/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    })
    const data: LoginResponse = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Login failed')
    }

    if (data.success && data.user) {
      return data.user
    }
    return null
  } catch (error) {
    console.error('Login error:', error)
    throw error
  }
}

export { login }
export type { User }
